import React from 'react'
import Svg, { Path, Rect } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export const SendArrowIcon: React.FC<SendArrowIconProps> = ({ size = 32, fillColor, backgroundColor, testID }) => {
  const { colors } = useTheme()

  return (
    <Svg width={size} height={size} viewBox='0 0 32 32' fill='none' testID={testID}>
      <Rect width='32' height='32' rx='16' fill={backgroundColor || colors.backgroundInactive} />
      <Path
        d='M16 22L16 10'
        stroke={fillColor || colors.iconDefault}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M10 16L16 10L22 16'
        stroke={fillColor || colors.iconDefault}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </Svg>
  )
}

export type SendArrowIconProps = {
  size?: number
  fillColor?: string
  backgroundColor?: string
  testID?: string
}
